import React from 'react';
import styled from 'styled-components';
import { ifProp } from 'styled-tools';

import { TABS } from 'theme';

const StyledTab = styled.button`
    display: inline-block;
    position: relative;
    padding: ${TABS.PADDING.Y} ${TABS.PADDING.X};
    background-color: transparent;
    border: 0;
    color: ${ifProp('active', TABS.COLOR.ACTIVE, TABS.COLOR.BASE)};
    font-size: ${TABS.FONT_SIZE};
    text-transform: uppercase;

    &:after {
        content: '';
        display: block;
        position: absolute;
        right: ${TABS.PADDING.X};
        bottom: 0;
        left: ${TABS.PADDING.X};
        height: 4px;
        background-color: ${ifProp('active', TABS.BORDER.ACTIVE, TABS.BORDER.BASE)};
    }
`;

const Tab = ({ children, ...props }) => {
    return (
        <StyledTab type="button" {...props}>
            {children}
        </StyledTab>
    );
};

export default Tab;
